"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TypescriptHelpers_1 = require("../../utils/TypescriptHelpers");
var FieldIcon_1 = require("../types/FieldIcon");
// These icons are from http://design/icons, in the 'Schema' section.
// Their names are intentionally kept the same as on that page for easy reference.
var SchemaViewerBoolCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerBoolCalcDiscrete");
var SchemaViewerBoolDiscrete_1 = require("../../../gen-src/icons/SchemaViewerBoolDiscrete");
var SchemaViewerDateCalcContinuous_1 = require("../../../gen-src/icons/SchemaViewerDateCalcContinuous");
var SchemaViewerDateCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerDateCalcDiscrete");
var SchemaViewerDateContinuous_1 = require("../../../gen-src/icons/SchemaViewerDateContinuous");
var SchemaViewerDateDiscrete_1 = require("../../../gen-src/icons/SchemaViewerDateDiscrete");
var SchemaViewerDateTimeCalcContinuous_1 = require("../../../gen-src/icons/SchemaViewerDateTimeCalcContinuous");
var SchemaViewerDateTimeCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerDateTimeCalcDiscrete");
var SchemaViewerDateTimeContinuous_1 = require("../../../gen-src/icons/SchemaViewerDateTimeContinuous");
var SchemaViewerDateTimeDiscrete_1 = require("../../../gen-src/icons/SchemaViewerDateTimeDiscrete");
var SchemaViewerGeoCalcContinuous_1 = require("../../../gen-src/icons/SchemaViewerGeoCalcContinuous");
var SchemaViewerGeoCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerGeoCalcDiscrete");
var SchemaViewerGeoContinuous_1 = require("../../../gen-src/icons/SchemaViewerGeoContinuous");
var SchemaViewerGeoDiscrete_1 = require("../../../gen-src/icons/SchemaViewerGeoDiscrete");
var SchemaViewerGroupDiscrete_1 = require("../../../gen-src/icons/SchemaViewerGroupDiscrete");
var SchemaViewerGroupGeoDiscrete_1 = require("../../../gen-src/icons/SchemaViewerGroupGeoDiscrete");
var SchemaViewerHierarchy_1 = require("../../../gen-src/icons/SchemaViewerHierarchy");
var SchemaViewerMeasuresNumberCalcContinuous_1 = require("../../../gen-src/icons/SchemaViewerMeasuresNumberCalcContinuous");
var SchemaViewerNumberCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerNumberCalcDiscrete");
var SchemaViewerNumberContinuous_1 = require("../../../gen-src/icons/SchemaViewerNumberContinuous");
var SchemaViewerNumberDiscrete_1 = require("../../../gen-src/icons/SchemaViewerNumberDiscrete");
var SchemaViewerNumericBin_1 = require("../../../gen-src/icons/SchemaViewerNumericBin");
var SchemaViewerNumericBinContinuous_1 = require("../../../gen-src/icons/SchemaViewerNumericBinContinuous");
var SchemaViewerSet_1 = require("../../../gen-src/icons/SchemaViewerSet");
var SchemaViewerTextCalcContinuous_1 = require("../../../gen-src/icons/SchemaViewerTextCalcContinuous");
var SchemaViewerTextCalcDiscrete_1 = require("../../../gen-src/icons/SchemaViewerTextCalcDiscrete");
var SchemaViewerTextContinuous_1 = require("../../../gen-src/icons/SchemaViewerTextContinuous");
var SchemaViewerTextDiscrete_1 = require("../../../gen-src/icons/SchemaViewerTextDiscrete");
var SchemaViewerUnknown_1 = require("../../../gen-src/icons/SchemaViewerUnknown");
function SvgFieldIcon(props) {
    if (!props.fieldIcon) {
        return React.createElement(SchemaViewerUnknown_1.SvgSchemaViewerUnknown, null);
    }
    switch (props.fieldIcon) {
        // Booleans are always discrete
        case FieldIcon_1.FieldIcon.BoolCalc:
            return React.createElement(SchemaViewerBoolCalcDiscrete_1.SvgSchemaViewerBoolCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.Bool:
            return React.createElement(SchemaViewerBoolDiscrete_1.SvgSchemaViewerBoolDiscrete, null);
        case FieldIcon_1.FieldIcon.DateCalcContinuous:
            return React.createElement(SchemaViewerDateCalcContinuous_1.SvgSchemaViewerDateCalcContinuous, null);
        case FieldIcon_1.FieldIcon.DateCalcDiscrete:
            return React.createElement(SchemaViewerDateCalcDiscrete_1.SvgSchemaViewerDateCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.DateContinuous:
            return React.createElement(SchemaViewerDateContinuous_1.SvgSchemaViewerDateContinuous, null);
        case FieldIcon_1.FieldIcon.DateDiscrete:
            return React.createElement(SchemaViewerDateDiscrete_1.SvgSchemaViewerDateDiscrete, null);
        case FieldIcon_1.FieldIcon.DateTimeCalcContinuous:
            return React.createElement(SchemaViewerDateTimeCalcContinuous_1.SvgSchemaViewerDateTimeCalcContinuous, null);
        case FieldIcon_1.FieldIcon.DateTimeCalcDiscrete:
            return React.createElement(SchemaViewerDateTimeCalcDiscrete_1.SvgSchemaViewerDateTimeCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.DateTimeContinuous:
            return React.createElement(SchemaViewerDateTimeContinuous_1.SvgSchemaViewerDateTimeContinuous, null);
        case FieldIcon_1.FieldIcon.DateTimeDiscrete:
            return React.createElement(SchemaViewerDateTimeDiscrete_1.SvgSchemaViewerDateTimeDiscrete, null);
        case FieldIcon_1.FieldIcon.GeoCalcContinuous:
            return React.createElement(SchemaViewerGeoCalcContinuous_1.SvgSchemaViewerGeoCalcContinuous, null);
        case FieldIcon_1.FieldIcon.GeoCalcDiscrete:
            return React.createElement(SchemaViewerGeoCalcDiscrete_1.SvgSchemaViewerGeoCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.GeoContinuous:
            return React.createElement(SchemaViewerGeoContinuous_1.SvgSchemaViewerGeoContinuous, null);
        case FieldIcon_1.FieldIcon.GeoDiscrete:
            return React.createElement(SchemaViewerGeoDiscrete_1.SvgSchemaViewerGeoDiscrete, null);
        // Groups are always discrete
        case FieldIcon_1.FieldIcon.Group:
            return React.createElement(SchemaViewerGroupDiscrete_1.SvgSchemaViewerGroupDiscrete, null);
        case FieldIcon_1.FieldIcon.GroupGeo:
            return React.createElement(SchemaViewerGroupGeoDiscrete_1.SvgSchemaViewerGroupGeoDiscrete, null);
        case FieldIcon_1.FieldIcon.Hierarchy:
            return React.createElement(SchemaViewerHierarchy_1.SvgSchemaViewerHierarchy, null);
        case FieldIcon_1.FieldIcon.NumberCalcContinuous:
            return React.createElement(SchemaViewerMeasuresNumberCalcContinuous_1.SvgSchemaViewerMeasuresNumberCalcContinuous, null); // This icon has an inconsistent name
        case FieldIcon_1.FieldIcon.NumberCalcDiscrete:
            return React.createElement(SchemaViewerNumberCalcDiscrete_1.SvgSchemaViewerNumberCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.NumberContinuous:
            return React.createElement(SchemaViewerNumberContinuous_1.SvgSchemaViewerNumberContinuous, null);
        case FieldIcon_1.FieldIcon.NumberDiscrete:
            return React.createElement(SchemaViewerNumberDiscrete_1.SvgSchemaViewerNumberDiscrete, null);
        case FieldIcon_1.FieldIcon.NumericBinContinuous:
            return React.createElement(SchemaViewerNumericBinContinuous_1.SvgSchemaViewerNumericBinContinuous, null);
        case FieldIcon_1.FieldIcon.NumericBinDiscrete:
            return React.createElement(SchemaViewerNumericBin_1.SvgSchemaViewerNumericBin, null); // This discrete icon has no suffix (unlike the others)
        case FieldIcon_1.FieldIcon.Set:
            return React.createElement(SchemaViewerSet_1.SvgSchemaViewerSet, null);
        case FieldIcon_1.FieldIcon.TextCalcContinuous:
            return React.createElement(SchemaViewerTextCalcContinuous_1.SvgSchemaViewerTextCalcContinuous, null);
        case FieldIcon_1.FieldIcon.TextCalcDiscrete:
            return React.createElement(SchemaViewerTextCalcDiscrete_1.SvgSchemaViewerTextCalcDiscrete, null);
        case FieldIcon_1.FieldIcon.TextContinuous:
            return React.createElement(SchemaViewerTextContinuous_1.SvgSchemaViewerTextContinuous, null);
        case FieldIcon_1.FieldIcon.TextDiscrete:
            return React.createElement(SchemaViewerTextDiscrete_1.SvgSchemaViewerTextDiscrete, null);
        case FieldIcon_1.FieldIcon.Unknown:
            return React.createElement(SchemaViewerUnknown_1.SvgSchemaViewerUnknown, null);
        default:
            // This is to cause a compile-time error if a case is missing.
            TypescriptHelpers_1.assertUnreachable(props.fieldIcon);
            return null; // This code is unreachable but requred by the complier.
    }
}
exports.SvgFieldIcon = SvgFieldIcon;
//# sourceMappingURL=SvgFieldIcon.js.map